import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryInstruction extends BaseModelAPI {
	static entity = 'deliveryinstruction';
	static entityName = 'deliveryinstruction';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.diNumber = '';
			this.deliveryOrderId = '';
			this.deliveryOrder = {};
			this.poNoCustomer = '';
			this.diDeliveryDate = '';
			this.diCreateDate = '';
			this.diStatusId = '';
			this.diStatus = {};
			this.diCustomerId = '';
			this.diCustomer = {};
			this.partDestinationId = '';
			this.partDestination = {};
			this.destinationId = '';
			this.destination = {};
			this.officeAddress = '';
			this.deliveryInstructionDetails = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

	static async printPdfCustom(this_, id) {
		return this_.$http.get(`${this.entityName}/printdeliveryinstruction/${id}`)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

	static async printDC(this_, ids) {
		return this_.$http.post(`${this.entityName}/printdc/`, ids)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

}